var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6271 8.08247L9.1141 15.5955C7.40556 17.304 4.63546 17.304 2.92692 15.5955C1.21837 13.8869 1.21837 11.1168 2.92692 9.4083L10.4399 1.89529C11.579 0.756258 13.4257 0.756258 14.5647 1.89529C15.7037 3.03432 15.7037 4.88105 14.5647 6.02008L7.34633 13.2385C6.77682 13.808 5.85345 13.808 5.28394 13.2385C4.71442 12.6689 4.71442 11.7456 5.28394 11.1761L11.6184 4.84157",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachement);
export default __webpack_public_path__ + "static/media/attachement.59146c5e21c7182f4f21e67f927b2b41.svg";
export { ForwardRef as ReactComponent };